export default __webpack_public_path__ + "static/media/doctor.d34f444c.jpg";